import { getSupabase } from 'src/utils/supabase';

export const userService = {
  getCurrentUser: async () => {
    try {
      const supabase = await getSupabase();
      const {
        data: { user },
      } = await supabase.auth.getUser();
      return user;
    } catch {
      return null;
    }
  },

  isAuthenticated: async (): Promise<boolean> => {
    try {
      const user = await userService.getCurrentUser();
      return !!user;
    } catch {
      return false;
    }
  },

  signOut: async (): Promise<void> => {
    const supabase = await getSupabase();
    const { error } = await supabase.auth.signOut();
    if (error) throw new Error('Failed to sign out');
  },

  getSession: async () => {
    try {
      const supabase = await getSupabase();
      const {
        data: { session },
      } = await supabase.auth.getSession();
      return session;
    } catch {
      return null;
    }
  },
};
